import { 
  REQUEST_STORIES,
  RECEIVE_STORIES,
  SET_ACTIVE_STORY,
  RECEIVE_STORIES_ERROR,
} from '../constants/actionTypes';

import {
  receiveErrorResponse,
} from './api';

import { fakeStoriesApi } from '../constants/fakeStories';

import api from '../api';

export const requestStories = () => ({
  type: REQUEST_STORIES,
});

export const receiveStories = (response) => ({
  type: RECEIVE_STORIES,
  response
});

export const setActiveStory = (id) => ({
  type: SET_ACTIVE_STORY,
  id,
});

export const receiveStoriesError = (error) => ({
  type: RECEIVE_STORIES_ERROR,
  error,
});

// For live
export function fetchStories() {
  return function(dispatch) {
    dispatch(requestStories());
    return api.get('/v1/real-story')
      .then((response) => {
        dispatch(receiveStories(response.data));
      })
      .catch((err) => {
        dispatch(receiveStoriesError(err));
      });
  };
}

// For test
// export function fetchStories() {
//     return function(dispatch) {
//         dispatch(requestStories());
//         dispatch(receiveStories(fakeStoriesApi));
//     };
// }